import React from "react";
// Components
import {
  GroupContainer,
  ColumnLabels,
  ColumnLabel,
  GroupHeader,
  GroupTitle,
  HeaderValue,
  RowsContainer,
  Row,
  RowInfo,
  RowName,
  RowDescription,
  RowImage,
  RowValue,
} from "./styles";
import Stepper from "../stepper";

// Sirve para los dos bloques de hardware, que solo se diferencian en donde
// estan el precio y la cantidad:
//  - el pack RGSclinic los lleva en la cabecera, y sus filas son solo el
//    contenido de la caja, sin precio propio
//  - RGS+ los lleva en cada fila, y la cabecera solo muestra el total
const ArticleGroup = ({ title, columnLabels, header, rows }) => {
  const renderStepper = (quantity) => (
    <Stepper value={quantity.value} onChange={quantity.onChange} max={quantity.max} />
  );

  return (
    <GroupContainer>
      <ColumnLabels>
        <span />
        <span />
        <ColumnLabel>{columnLabels.price}</ColumnLabel>
        <ColumnLabel>{columnLabels.quantity}</ColumnLabel>
        <ColumnLabel>{columnLabels.total}</ColumnLabel>
      </ColumnLabels>

      <GroupHeader>
        <GroupTitle>{title}</GroupTitle>
        <span />
        <HeaderValue>{header.price}</HeaderValue>
        {header.quantity ? renderStepper(header.quantity) : <span />}
        <HeaderValue>{header.total}</HeaderValue>
      </GroupHeader>

      <RowsContainer>
        {rows.map((row, i) => (
          <Row key={row.key} $isEven={i % 2 !== 0}>
            <RowInfo>
              <RowName>{row.name}</RowName>
              <RowDescription>{row.description}</RowDescription>
            </RowInfo>
            <RowImage src={row.image} alt={row.name} />
            <RowValue>{row.price}</RowValue>
            {row.quantity ? renderStepper(row.quantity) : <span />}
            <RowValue>{row.total}</RowValue>
          </Row>
        ))}
      </RowsContainer>
    </GroupContainer>
  );
};

export default ArticleGroup;
